import './employerCalender.scss';

interface ICell {
    color: string;
    startTime: number;
    endTime: number;
    id: number;
}

interface IColumn {
    cells: ICell[];
}
interface IRow {
    columns: IColumn[];
}

interface IColumnHeader {
    url: string;
    name: string;
    type: string;
}

interface IWeekNumberCalender {
    onTabClick(data: ICell): any;
}

const WeekNumberCalender = ({ onTabClick }: IWeekNumberCalender) => {
    const hourCount = 24;
    const hourCountHeader = '직원목록';
    const weekStartDate = 23;
    const hourCountLabels = new Array<number>(hourCount);
    const customElements = [
        {
            date: 23,
            startTime: 9,
            endTime: 18,
            color: '#49ae9e',
            id: 1,
        },
        {
            date: 24,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            id: 2,
        },
        {
            date: 25,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            id: 3,
        },
        {
            date: 26,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            id: 3,
        },
        {
            date: 27,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            id: 3,
        },
        {
            date: 28,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            id: 3,
        },
    ];
    const columnHeaders: IColumnHeader[] = [
        {
            url: 'https://i.pravatar.cc/150?img=14',
            name: '홍길동',
            type: '매니저',
        },
        {
            url: 'https://i.pravatar.cc/150?img=24',
            name: '홍길동',
            type: '사원',
        },
        {
            url: 'https://i.pravatar.cc/150?img=34',
            name: '홍길동',
            type: '사원',
        },
        {
            url: 'https://i.pravatar.cc/150?img=44',
            name: '홍길동',
            type: '사원',
        },
        {
            url: 'https://i.pravatar.cc/150?img=54',
            name: '홍길동',
            type: '사원',
        },
        {
            url: 'https://i.pravatar.cc/150?img=64',
            name: '홍길동',
            type: '사원',
        },
    ];

    for (let index = 0; index < hourCount; index++) {
        hourCountLabels.push(index);
    }

    //create 2d array
    const tableDaysArray: ICell[][] = new Array(6).fill(false).map(() =>
        new Array(24).fill({
            color: null,
            startTime: 0,
            endTime: 5,
            userList: [],
        }),
    );

    //feed 2d array
    for (const key in customElements) {
        const element = customElements[key];
        const { date, ...elementWithoutDate } = element;
        tableDaysArray[element.date - weekStartDate][element.startTime] = elementWithoutDate;
    }

    return (
        <div className="employeeCalenderComponent ">
            <div className="contentWrapper">
                <table className="table">
                    <tr className="topRow">
                        <th className="weekNumberHeaderTitle">{hourCountHeader}</th>
                        {hourCountLabels.map((label) => {
                            return <th className="weekNumberHeader">{label}</th>;
                        })}
                    </tr>
                    {tableDaysArray.map((row, index) => {
                        return (
                            <tr>
                                <td className="columnHeaders">
                                    <div className="imageWrapper">
                                        <img src={columnHeaders[index].url} alt="" />
                                    </div>
                                    <div className="text">
                                        <div className="header">{columnHeaders[index].name}</div>
                                        <div className="subHeader">{columnHeaders[index].type}</div>
                                    </div>
                                </td>
                                {row.map((hour) => {
                                    return (
                                        <td className="normalCell">
                                            {hour.color != null ? (
                                                <div
                                                    className="dataContainer"
                                                    style={{
                                                        width: `${103.56 * (hour.endTime - hour.startTime)}%`,
                                                        background: hour.color,
                                                    }}
                                                    onClick={() => {
                                                        onTabClick(hour);
                                                    }}
                                                >
                                                    {`${hour.startTime}:00  ~  ${hour.endTime}:00`}
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </table>
            </div>
        </div>
    );
};

export default WeekNumberCalender;
